import {dropbox_os} from '@dropbox/api-v2-client';
import type {ReplitCatalogApp} from 'client';

export type ReplitPublishedAppDetails = {
  '.tag': 'replit';
  artifact_id?: string;
  edit_url?: string;
  is_owned: boolean;
  publication_state: 'draft' | 'published';
  project_id: string;
  workspace_id: string;
};

export type ReplitPublishedApp = Omit<
  dropbox_os.PublishedApp,
  'launch_url' | 'platform' | 'platform_details'
> & {
  description?: string;
  id: string;
  launch_url?: string;
  platform: {'.tag': 'replit'};
  platform_details: ReplitPublishedAppDetails;
  published_at?: string;
  title: string;
};

export type CatalogApp = dropbox_os.PublishedApp | ReplitPublishedApp;

export const isReplitApp = (app: CatalogApp): app is ReplitPublishedApp =>
  app.platform?.['.tag'] === 'replit';

export const isReplitDraft = (app: CatalogApp) =>
  isReplitApp(app) && app.platform_details.publication_state === 'draft';

export const fromReplitCatalogApp = (app: ReplitCatalogApp): ReplitPublishedApp => ({
  id: app.id,
  slug: app.slug ?? undefined,
  launch_url: app.launch_url ?? undefined,
  platform: {'.tag': 'replit'},
  owner: app.owner.username
    ? {
        principal: {
          '.tag': 'user',
          username: app.owner.username,
        },
      }
    : undefined,
  platform_details: {
    '.tag': 'replit',
    artifact_id: app.details.artifact_id ?? undefined,
    edit_url: app.details.edit_url ?? undefined,
    is_owned: app.is_owned,
    publication_state: app.publication_state,
    project_id: app.details.project_id,
    workspace_id: app.details.workspace_id,
  },
  published_at: app.details.published_at ?? app.details.updated_at ?? undefined,
  title: app.title,
  description: app.description ?? undefined,
});
